const bom = {
  bomType: "Bom 类型",
  bomCode: '母件编码',
  bomName: '母件名称',
  bomModal: '物料规格',
  bomUnit: '计量单位',
  bomVersion: '版本号',
  bomVersionDesc: '版本说明',
  bomVersionDate: '版本日期',
  bomStatus: 'Bom状态',
  approvaler: '审核人',
  createDate: '建档日期',
  creator: '建档人',
  updateDate: '修改日期',
  updater: '修改人',

  itemLevel: '层级',
  itemCode: '子件编码',
  itemName: '子件名称',
  itemModal: '子件规格',
  itemUnit: '计量单位',
  itemBase: '基本数量',
  itemBaseQuantity: '基础数量',
  itemAttritionRate: '子件损耗率',
  itemUseQuantity: '使用数量',
  itemEffectiveDate: '生效日期',
  itemExpiringDate: '失效日期',
  itemReMark: '备注',
  itemLocators: '定位符1',
  itemExtraRate: '备品率',

  itemLevelInfo: '第 {{ level }} 层',
  itemReq: '替代料',

  plBaseUnit: '请输入基本数量',
  plBaseQuantity: '请输入基础数量',
  plAttritionRate: '请输入子件损耗率',
  plUseQuantity: '请输入使用数量',
  plRemark: '请输入备注',
  plLocators: '请输入定位符1',

  importError: '导入失败',
  bomUpload: '导入BOM表',
  bomDetail: 'BOM表详情',
  closeTip: "需求清单还未生成，确定要关闭吗？",
  errTip: "请检查数据",
  errTipdesc: "至少一个物料的所需数量大于0才可继续",
  stockNum: "库存数量",

  reqManage: "需求清单管理",
  preStock: "库存预出库数量",
  preInStock: "库存预入库数量",
  useStock: "可用库存数量",
  prePurNum: "需采购数量(常备品为0)",
  prePurNum_1: "需采购数量",
  preOutNum: "预出库数量(常备品不做预出库)",
  preOutNum_1: "预出库数量",
  matchErr: "库存匹配失败",
  noSaleOrderOrProduct: "需求清单没有母件，无法进行生产数量领料",
  bomUsageMatchErr: "BOM匹配失败，无法进行生产数量领料",
  confirmAdd: "添加需求清单(预出库单)",
  inventorySucc: "预出库单:{{number}}已生成，出库库位已分配",
  saveTemp: "是否保存模版？",
  merge: "物料：{{codes}}有重复，其所需数量已相加",
  editBom: "编辑BOM表",
  addBom: "新增BOM表",

  materialControlTemplate: "物控需求模版",
  originBom: "主料",
  calcErr: "组合用料数量分配错误！",
  calcData: "需满足：主料的所需数量 + 所有替代料的所需数量之和 = 主料的标准数量总数",
  allocated: "已使用库存量",
  expandAll: "全部展开",
  collapseAll: "全部折叠",
  uploadBom: "上传bom附件",
  parseBonErr: "bom解析失败",
  addTip: "以下物料在系统中不存在，是否需要添加这些物料？",
  notItem: "以下物料在系统中不存在，将不会生成需求单数据",
  fileErr: "BOM附件信息获取失败",
  facStock: "产线库存",
  facStockAlloc: "已使用产线库存量",
  useFactoryCount: "产线库存用量",
  realStockNum: "在库库存数量",
  realPreStock: "在库库存预出库数量",
  realUseStock: "可用在库库存数量",
  realAllocated: "已使用在库库存量",
  bomNull: "没有可用的BOM数据源",
  bomNullTip: "至少保证销售单BOM文件、模版、系统BOM数据三者中有一个",
};

export default bom;
